export class ProxyRequest
{
    constructor(
            public readonly method:string, 
            public readonly url:string, 
            public readonly body:string, 
            public readonly headers:any
        )
    {}
}
